import { Container, Texture, clamp } from '../../../odie';
import { COOLER_BOX_SODA_ROCKETS } from '../../actions/effects/CoolerEffect';
import { CoolerBlockProps } from '../../defs/block';
import { config } from '../../defs/config';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

const assets: Record<string, string> = {
  close: 'cooler/block.cooler.close.png',
  '0': 'cooler/block.cooler.0.png',
  '1': 'cooler/block.cooler.1.png',
  '2': 'cooler/block.cooler.2.png',
  '3': 'cooler/block.cooler.3.png',
  '4': 'cooler/block.cooler.4.png',
  '5': 'cooler/block.cooler.5.png',
  '6': 'cooler/block.cooler.6.png',
  soda: 'cooler/block.cooler.soda.png',
};

export class CoolerBlockView extends Container {
  private sprite: FitWidthBlockSprite;
  private _count = 0;
  private _sodas = COOLER_BOX_SODA_ROCKETS;

  constructor(props: CoolerBlockProps) {
    super();
    this.sprite = new FitWidthBlockSprite(assets.close, props);
    this.sprite.scaleX = this.sprite.scaleY = 0.6;
    this.y = config.tile.size * 0.5 + 5;
    this.addChild(this.sprite);
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return Object.values(assets);
  }

  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    this._count = value;
    this.updateView();
  }

  public get sodas(): number {
    return this._sodas;
  }

  public set sodas(value: number) {
    this._sodas = clamp(Math.floor(value), 0, COOLER_BOX_SODA_ROCKETS);
    this.updateView();
  }

  private updateView() {
    if (this._count === 1) {
      this.sprite.texture = Texture.from(assets.close);
      return;
    }

    const image = assets[this._sodas.toString()];
    this.sprite.texture = Texture.from(image);
  }
}
